/* ===== AROMAZUR — ruptures de stock : marquage + blocage ====================
   Source de verite : window.AZ_RUPTURE, ecrit par layout/theme.liquid a chaque
   requete depuis Shopify. Ne contient QUE les indisponibles (quelques centaines
   d'octets). az-db.js est une base statique sans stock : tout ce qui la lit —
   accueil, modale, selecteur d'huiles des packs — est aveugle sans ce fichier.

   Trois couches :
     1. MARQUAGE  cartes, vignettes d'huiles, formats de la fiche produit
     2. BLOCAGE   selection et ajout au panier impossibles
     3. FILET     derniere verification avant le passage en caisse

   PERFORMANCE : aucun observateur permanent sur le document. On enveloppe les
   fonctions du theme qui produisent du contenu (renderOilPicker, addLine,
   toggleOil) et on repasse ponctuellement. Le seul observateur est limite au
   bloc « Choisissez votre formule », construit en differe par az-offres.js,
   et il se coupe des qu'il a fait son travail.

   La garantie absolue reste cote Shopify : « Continuer la vente une fois en
   rupture » doit etre DECOCHE sur chaque variante. Ce fichier evite au client
   d'arriver jusqu'a l'erreur.                                              */
(function () {
  'use strict';

  var LABEL = 'Rupture de stock';
  var COURT = 'Rupture';

  function R() { return window.AZ_RUPTURE || null; }

  /* Inconnu = disponible. On ne bloque jamais sur une absence de donnee :
     mieux vaut laisser passer que casser la vente d'une reference hors des
     collections listees.                                                    */
  function dispoProduit(h) {
    var r = R(); if (!r || !h) return true;
    return !r.p[String(h).replace(/^az-/, '')];
  }
  function dispoVariante(id) {
    var r = R(); if (!r || id == null) return true;
    return !r.v[String(id)];
  }
  function handleDeLien(u) {
    var m = String(u || '').match(/\/products\/([a-z0-9\-_%]+)/i);
    return m ? m[1] : '';
  }
  function titreVersHandle(t) {
    var DB = window.AZ_DB || window.DB;
    if (!DB || !t) return '';
    for (var k in DB) if (DB[k] && DB[k].title === t) return DB[k].handle || k;
    return '';
  }

  /* ------------------------------------------------------------------ *
   *  1. CARTES PRODUIT — accueil, collections, recherche, recommandations
   * ------------------------------------------------------------------ */
  function marqueCartes(racine) {
    var n = (racine || document).querySelectorAll('.card:not([data-az-stock])');
    for (var i = 0; i < n.length; i++) {
      var c = n[i];
      c.setAttribute('data-az-stock', '1');
      var lien = c.getAttribute('href') || c.getAttribute('onclick') || '';
      if (!lien) { var a = c.querySelector('a[href]'); if (a) lien = a.getAttribute('href') || ''; }
      var h = handleDeLien(lien);
      if (!h || dispoProduit(h)) continue;
      c.classList.add('az-rupture');
      var img = c.querySelector('.card-img') || c;
      if (!img.querySelector('.az-rupture-badge')) {
        var b = document.createElement('span');
        b.className = 'az-rupture-badge';
        b.textContent = COURT;
        img.appendChild(b);
      }
      var add = c.querySelector('.add');
      if (add) add.textContent = 'Voir';
    }
  }

  /* ------------------------------------------------------------------ *
   *  2. SELECTEURS D'HUILES
   *     .po-oil  modale de l'accueil (packs)
   *     .az-h    bloc « Choisissez votre formule » des fiches diffuseur
   * ------------------------------------------------------------------ */
  function marqueVignettes(racine) {
    /* .abo-scent ajoute le 08/09/2026 : la grille des parfums d'abonnement
       listait les 32 huiles sans aucun filtre de stock. */
    var n = (racine || document).querySelectorAll(
      '.po-oil[data-h]:not([data-az-stock]),' +
      '.az-h[data-h]:not([data-az-stock]),' +
      '.abo-scent[data-h]:not([data-az-stock])');
    for (var i = 0; i < n.length; i++) {
      var b = n[i];
      b.setAttribute('data-az-stock', '1');
      if (dispoProduit(b.getAttribute('data-h'))) continue;
      b.classList.add('az-rupture');
      b.disabled = true;
      b.setAttribute('aria-disabled', 'true');
      b.setAttribute('title', LABEL);
      if (!b.querySelector('.az-rupture-tag')) {
        var s = document.createElement('span');
        s.className = 'az-rupture-tag';
        s.textContent = COURT;
        b.appendChild(s);
      }
    }
    return n.length;
  }

  function refuse(nom) {
    var err = document.getElementById('azOffreErr');
    var txt = '« ' + (nom || 'Cet article') + ' » est en rupture de stock.';
    if (err) { err.textContent = txt + ' Choisissez une autre signature.'; return; }
    alert(txt);
  }

  /* Filet sur le clic : couvre les vignettes creees apres notre passage,
     y compris celles a gestionnaire « onclick » en attribut. Un seul
     ecouteur delegue, en phase de capture, cout negligeable.               */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('.az-h[data-h],.po-oil[data-h],.abo-scent[data-h]');
    if (!b || dispoProduit(b.getAttribute('data-h'))) return;
    e.preventDefault(); e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var n = b.querySelector('.az-h-t,.abo-scent-info h5,span');
    refuse((n && n.textContent) || 'Cette signature');
  }, true);

  /* ------------------------------------------------------------------ *
   *  3. FICHE PRODUIT — boutons de format (20/50/120/500 ml)
   * ------------------------------------------------------------------ */
  function marqueFormats() {
    var lignes = document.querySelectorAll('.pp-opt');
    if (!lignes.length) return;
    var V = [];
    try {
      var n = document.getElementById('ppVariants');
      V = n ? JSON.parse(n.textContent || '[]') : [];
    } catch (e) { return; }
    if (!V.length) return;
    for (var i = 0; i < lignes.length; i++) {
      var btns = lignes[i].querySelectorAll('.fmt');
      for (var j = 0; j < btns.length; j++) {
        var btn = btns[j], val = btn.getAttribute('data-value'), possible = false;
        for (var k = 0; k < V.length; k++) {
          var v = V[k];
          if (v['option' + (i + 1)] !== val) continue;
          if (v.available !== false && dispoVariante(v.id)) { possible = true; break; }
        }
        btn.classList.toggle('az-rupture', !possible);
        btn.disabled = !possible;
        if (!possible) {
          btn.setAttribute('aria-disabled', 'true');
          btn.setAttribute('title', LABEL);
          btn.classList.remove('on');
        }
      }
    }
  }

  /* ------------------------------------------------------------------ *
   *  4. BLOCAGE DE L'AJOUT AU PANIER
   *     addLine() est le passage oblige de tout l'accueil (modale, packs,
   *     abonnements). toggleOil() est la selection d'une huile de pack.
   * ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     Resolution de la variante d'une ligne de panier.

     L'ancienne version identifiait la variante par son INDEX dans la base
     du theme (l.fmtIdx). Deux defauts, tous deux constates en production :
       - az-offres.js transmet toujours fmtIdx = 0 ;
       - l'ordre des variantes dans la base ne correspond pas toujours a
         celui de Shopify (Nebula Pro 600 : Noir est en position 0 dans la
         base et en position 1 chez Shopify).
     Consequence : sur un diffuseur dont le Noir etait epuise, un client
     qui commandait le Blanc voyait son passage en caisse refuse.

     On identifie desormais la variante par son identifiant, puis par son
     titre, et seulement en dernier recours par son index. Et si la variante
     ne peut pas etre identifiee avec certitude, on NE BLOQUE PAS : mieux
     vaut laisser Shopify refuser une ligne reellement indisponible que
     d'empecher une commande valide.
     ------------------------------------------------------------------ */
  function varianteDeLaLigne(l) {
    var DB = window.AZ_DB || window.DB;
    if (!DB || !l || !l.handle) return null;
    var p = DB[l.handle] || DB['az-' + String(l.handle).replace(/^az-/, '')];
    if (!p || !p.variants || !p.variants.length) return null;
    var i;
    /* 1. identifiant explicite */
    if (l.variantId != null) {
      for (i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(l.variantId)) return p.variants[i];
    }
    /* 2. identifiant glisse dans la cle « handle|123456789 » */
    var m = String(l.key || '').match(/\|(\d{6,})/);
    if (m) { for (i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === m[1]) return p.variants[i]; }
    /* 3. titre de la variante (format d'huile ou coloris) */
    var t = String(l.fmt || l.variantTitle || '').trim().toLowerCase();
    if (t) { for (i = 0; i < p.variants.length; i++) if (String(p.variants[i].title || '').trim().toLowerCase() === t) return p.variants[i]; }
    /* 4. index — uniquement si le produit n'a qu'une variante, sinon trop risque */
    if (p.variants.length === 1) return p.variants[0];
    return null;
  }

  function ligneBloquee(l) {
    if (!l) return '';
    if (l.handle && !dispoProduit(l.handle)) return l.title || 'Cet article';
    if (l.variantId != null && !dispoVariante(l.variantId)) return l.title || 'Cet article';
    var v = varianteDeLaLigne(l);
    if (v && v.id != null && !dispoVariante(v.id)) return (l.title || 'Cet article') + ' ' + (v.title || '');
    /* huiles d'un pack : stockees sous forme de TITRES */
    if (l.oils && l.oils.length) {
      for (var i = 0; i < l.oils.length; i++) {
        var o = l.oils[i];
        var h = dispoProduit(o) ? titreVersHandle(o) : o;
        if (h && !dispoProduit(h)) return o;
      }
    }
    return '';
  }
  window.azStockLigneBloquee = ligneBloquee;

  /* ------------------------------------------------------------------ *
   *  3 bis. PARCOURS ABONNEMENT ET BLOC « CHOISISSEZ VOTRE FORMULE »
   *
   *  Trois trous constates le 08/09/2026 :
   *    - openAboModal construisait la grille des 32 parfums sans filtre de
   *      stock, et sans repasser le marquage apres l'avoir rendue ;
   *    - confirmAbo poussait directement dans CART, sans passer par addLine,
   *      donc sans aucun garde-fou ;
   *    - le bouton d'ajout du bloc « formule » restait actif meme quand le
   *      diffuseur lui-meme etait en rupture : le client composait toute sa
   *      commande avant d'etre refuse au paiement.
   * ------------------------------------------------------------------ */
  function nomHuile(h) {
    var DB = window.AZ_DB || window.DB;
    var p = DB && (DB[h] || DB['az-' + String(h).replace(/^az-/, '')]);
    return (p && p.title) ? String(p.title).replace(/^Huile\s*/, '') : 'Cette signature';
  }

  function enveloppeAbonnement() {
    if (typeof window.openAboModal === 'function' && !window.openAboModal._azStock) {
      var _oam = window.openAboModal;
      window.openAboModal = function () {
        var r = _oam.apply(this, arguments);
        try { marqueVignettes(document.getElementById('aboScentGrid') || document); } catch (e) {}
        return r;
      };
      window.openAboModal._azStock = 1;
    }
    if (typeof window.pickAboScent === 'function' && !window.pickAboScent._azStock) {
      var _pas = window.pickAboScent;
      window.pickAboScent = function (h) {
        if (!dispoProduit(h)) { refuse(nomHuile(h)); return; }
        return _pas.apply(this, arguments);
      };
      window.pickAboScent._azStock = 1;
    }
    if (typeof window.confirmAbo === 'function' && !window.confirmAbo._azStock) {
      var _ca = window.confirmAbo;
      window.confirmAbo = function () {
        var h = window.aboScent;
        if (h && !dispoProduit(h)) { refuse(nomHuile(h)); return; }
        return _ca.apply(this, arguments);
      };
      window.confirmAbo._azStock = 1;
    }
  }

  /* Bloc « Choisissez votre formule » : desactiver l'ajout si l'appareil
     lui-meme est en rupture, et le dire en haut du bloc. */
  function marqueBlocFormule() {
    var add = document.getElementById('azOffreAdd');
    if (!add) return;
    var h = '';
    var n = document.getElementById('ppHandle');
    if (n) h = n.textContent || n.value || '';
    if (!h) {
      var m = String(location.pathname || '').match(/\/products\/([^/?#]+)/);
      if (m) h = decodeURIComponent(m[1]);
    }
    if (!h || dispoProduit(h)) return;
    add.disabled = true;
    add.setAttribute('aria-disabled', 'true');
    add.textContent = 'Rupture de stock';
    add.classList.add('az-rupture');
    var err = document.getElementById('azOffreErr');
    if (err && !err.textContent) {
      err.textContent = 'Cet appareil est momentanement en rupture de stock. Ecrivez-nous a contact@aromazur.fr pour etre prevenu de son retour.';
    }
  }

  function enveloppe() {
    if (typeof window.addLine === 'function' && !window.addLine._azStock) {
      var _al = window.addLine;
      window.addLine = function (handle, fmtIdx, q, oils) {
        /* On passe par la fonction globale : az-stock-patch.js la remplace apres
           coup, et l'ancien appel a la locale rendait ce correctif inoperant. */
        var verif = window.azStockLigneBloquee || ligneBloquee;
        var ko = verif({ handle: handle, fmtIdx: fmtIdx, oils: oils });
        if (ko) { refuse(ko); return; }
        return _al.apply(this, arguments);
      };
      window.addLine._azStock = 1;
    }
    if (typeof window.toggleOil === 'function' && !window.toggleOil._azStock) {
      var _to = window.toggleOil;
      window.toggleOil = function (h) {
        if (!dispoProduit(h)) { refuse(h); return; }
        return _to.apply(this, arguments);
      };
      window.toggleOil._azStock = 1;
    }
    if (typeof window.renderOilPicker === 'function' && !window.renderOilPicker._azStock) {
      var _rp = window.renderOilPicker;
      window.renderOilPicker = function () {
        var r = _rp.apply(this, arguments);
        marqueVignettes(document.getElementById('mOils') || document);
        return r;
      };
      window.renderOilPicker._azStock = 1;
    }
  }

  /* ------------------------------------------------------------------ *
   *  5. FILET AVANT PAIEMENT — appele par az-cart-fix.js
   *     Une reference peut etre tombee en rupture entre deux visites : le
   *     panier vit dans le navigateur du client.
   * ------------------------------------------------------------------ */
  window.azStockVerifiePanier = function (cart) {
    var ko = [];
    for (var i = 0; i < (cart || []).length; i++) {
      var m = ligneBloquee(cart[i]);
      if (m && ko.indexOf(m) < 0) ko.push(m);
    }
    return ko;
  };

  /* ------------------------------------------------------------------ *
   *  Application
   * ------------------------------------------------------------------ */
  function passe() {
    marqueCartes(); marqueVignettes(); marqueFormats();
    marqueBlocFormule(); enveloppe(); enveloppeAbonnement();
  }
  window.azStockRefresh = passe;

  function boot() {
    if (!R()) return;                       /* donnees absentes : on ne fait rien */
    passe();
    /* az-db.js et les scripts d'accueil sont charges en bas de page */
    window.addEventListener('load', passe, { once: true });

    /* Un seul observateur, limite au bloc « Choisissez votre formule » des
       fiches diffuseur : az-offres.js le construit en differe. Il se coupe
       des qu'il a marque des vignettes, ou au bout de 15 secondes.         */
    var hote = document.getElementById('ppForm');
    if (hote && hote.parentNode && window.MutationObserver) {
      var obs = new MutationObserver(function () {
        if (marqueVignettes(hote.parentNode)) obs.disconnect();
      });
      obs.observe(hote.parentNode, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 15000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
